import React, {useCallback} from 'react'
import {Row, Col, AttentionIcon, H4, CustomerDialogButtonRow} from '@modifi/ui'
import {warning} from '@modifi/colors'
import {useTranslation} from '@modifi/plugin-i18n'

import {userPreferences} from '../../../../../utils/user-preferences'
import {StyledP} from './styles'
import {preunderwritingSubmitStateKeyPrefix} from '../../constants'

declare global {
  interface Window {
    dataLayer: any[]
  }
}

type PreunderwritingSubmitConfirmationDialogProps = {
  submitDialog: () => void
  closeDialog: () => void
  externalCompanyId: string
}

const PreunderwritingSubmitConfirmationDialog: React.FC<
  PreunderwritingSubmitConfirmationDialogProps
> = ({submitDialog, closeDialog, externalCompanyId}) => {
  const {t} = useTranslation('charon')

  const handleSubmit = useCallback(() => {
    const preunderwritingSubmitStateKey = `${preunderwritingSubmitStateKeyPrefix}:${externalCompanyId}`
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      event: 'pre_onboarding_confirmation_submit',
      element_id: 'pre_onboarding_confirmation_submit',
      element_type: 'button',
    })
    userPreferences.set(preunderwritingSubmitStateKey, 'true')
    submitDialog()
  }, [submitDialog, externalCompanyId])

  return (
    <>
      <Row justifyContent="center">
        <Col col="auto">
          <AttentionIcon color={warning} height={55} width={63} />
        </Col>
      </Row>
      <Row>
        <Col>
          <H4 textAlign="center">{t('preunderwriting-submit-confirmation-dialog.headline')}</H4>
        </Col>
      </Row>
      <Row justifyContent="center">
        <Col>
          <StyledP>
            {t('preunderwriting-submit-confirmation-dialog.confirmation-description')}
          </StyledP>
        </Col>
      </Row>
      <CustomerDialogButtonRow
        canSubmit
        onSubmitClick={handleSubmit}
        submitText={t('preunderwriting-submit-confirmation-dialog.cta-submit.label')}
        hasCancel
        canCancel
        cancelText={t('preunderwriting-submit-confirmation-dialog.cta-cancel.label')}
        onCancelClick={closeDialog}
      />
    </>
  )
}

export default PreunderwritingSubmitConfirmationDialog
